import React from 'react';
import ReactDOM from 'react-dom';

import Store from 'store';

import { VirtualList } from 'ui/virtual';

import './itemTable.scss';
import { gameTipClasses, createTipNode } from './gametips';
import { keyedList, searchRegex } from 'utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';

function ItemTable({ data }) {
  const [search, setSearch] = React.useState('');
  const onSetSearch = React.useCallback(e => setSearch(e.target.value), []);
  const onClearSearch = React.useCallback(() => setSearch(''), []);

  const searchRe = React.useMemo(() => searchRegex(search, true), [search]);

  const items = React.useMemo(() => data.filter(row => !searchRe || row.name.match(searchRe)), [data, searchRe]);

  const renderRow = React.useCallback(row => (
    <li key={row.id}>
      <span><span>{row.title}</span></span>
      <span><span>{row.cells[0]}</span></span>
      <span><span>{row.cells[1]}</span></span>
      <span><span>{row.cells[2]}</span></span>
    </li>
  ), []);

  return (
    <div className="d3p-ItemTable">
      <div className="d3p-table-head">
        <span>
          <input placeholder="Search" value={search} onChange={onSetSearch}/>
          {!!search.trim() && <FontAwesomeIcon icon={faTimesCircle} className="d3p-clear" onClick={onClearSearch}/>}
        </span>
        <span>Fate</span>
        <span>Class</span>
        <span>Used for</span>
      </div>
      <VirtualList className="d3p-table-body" items={items} renderItem={renderRow} maxHeight={1000} itemHeight={50}/>
    </div>
  );
}

function formatText(node, dtLinks) {
  return keyedList([...node.childNodes].map(node => {
    if (node.nodeType === 3) {
      return node.textContent;
    } else if (node.nodeType === 1) {
      if (node.tagName === 'SPAN') {
        const className = node.className;
        if (className && gameTipClasses.some(cls => className.includes(cls))) {
          const embed = createTipNode(node);
          if (embed) {
            return <span className={node.className}>{embed}</span>;
          }
        }
        return <span className={className}>{formatText(node, dtLinks)}</span>;
      } else if (node.tagName === 'BR') {
        return <br/>;
      } else if (node.tagName === 'A') {
        const href = node.getAttribute('href');
        return <a href={href} target="_blank" rel="noopener noreferrer">{formatText(node, dtLinks)}</a>;
      } else {
        console.log(`unknown tag ${node.tagName}`);
        return formatText(node, dtLinks);
      }
    } else {
      console.log(`unknown node type ${node.nodeType}`);
      return node.textContent;
    }
  }));
}

function parseTable(table) {
  const result = [];
  let index = 0;
  for (const row of [...table.querySelectorAll('tr')].slice(1)) {
    const cells = row.querySelectorAll('td');
    if (cells.length < 1) continue;
    const data = {
      id: ++index,
      name: cells[0].querySelector('.d3planner-item')?.textContent.trim() || '',
      title: formatText(cells[0], true),
    };
    data.cells = [...cells].slice(1).map(cell => formatText(cell));
    result.push(data);
  }
  return result;
}

export default function makeItemTable() {
  const store = new Store({embed: true});

  for (const root of document.querySelectorAll('.d3planner-item-table')) {
    try {
      const data = parseTable(root);
      const repl = document.createElement('div');
      root.replaceWith(repl);
      ReactDOM.render((
        <Store.Provider store={store}>
          <ItemTable data={data}/>
        </Store.Provider>
      ), repl);
    } catch (e) {
      console.error(e);
    }
  }
}
